import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";

export default function ShowroomCard({ product, index = 0, span = 1 }) {
  const { lang, t } = useLanguage();
  const name = lang === "de" ? product.name_de : product.name_en;
  const image = product.images?.[0] || "https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=800&q=80";
  const isFeatured = product.status === "featured";

  return (
    <motion.div
      data-testid={`showroom-card-${product.id}`}
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.07, ease: [0.25, 0.1, 0.25, 1] }}
      className={`showroom-card group relative overflow-hidden rounded-sm cursor-pointer ${isFeatured ? "featured-glow" : ""}`}
    >
      <Link to={`/shop/${product.id}`} className="block h-full">
        {/* Image container */}
        <div className={`relative overflow-hidden bg-surface/50 ${span === 2 ? "aspect-[16/9]" : "aspect-square"}`}>
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
            loading="lazy"
          />

          {/* Dark gradient overlay always present, intensifies on hover */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />

          {/* Content pinned to bottom */}
          <div className="absolute bottom-0 left-0 right-0 p-5">
            {isFeatured && (
              <span className="inline-block mb-2 text-[9px] font-mono tracking-[0.25em] uppercase text-white/50">
                {t("product.featured")}
              </span>
            )}
            <h3 className={`font-heading font-bold tracking-tight text-white leading-tight translate-y-1 group-hover:translate-y-0 transition-transform duration-300 ${span === 2 ? "text-xl" : "text-base"}`}>
              {name}
            </h3>
            <p className="text-[11px] font-mono text-white/30 mt-1 tracking-wider capitalize opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {product.category} — {product.material}
            </p>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
